// status-hub.view — B1: menu "Status Hutang, Piutang" = tab menyamping menggabung
// Status Pembayaran + Piutang + Hutang Supplier + DP. Tiap tab memanggil render fn yang
// SUDAH ADA (tak diubah). Tab di-gate per-peran (mis. Teknisi hanya lihat DP, CS hanya Status Pembayaran).
import { currentUser } from '@core/session';
import type { Role } from '@core/types';
import { renderPayments } from './payments.view';
import { renderPiutang, renderLapDP } from '@modules/finance/finance.view';
import { renderHutangSupplier } from '@modules/sparepart/sparepart.view';
import { supplierMenagihCount } from '@modules/sparepart/sparepart.repo';
import { renderBayarKomisi } from '@modules/finance/payout.view';

interface ShpTab { k: string; l: string; roles: Role[]; fn: (root: HTMLElement) => Promise<void> }
const SHP_TABS: ShpTab[] = [
  { k: 'bayar', l: '💳 Status Pembayaran', roles: ['Owner', 'Manager', 'Admin Finance', 'SPV', 'CS'], fn: renderPayments },
  { k: 'piutang', l: '📒 Piutang', roles: ['Owner', 'Manager', 'Admin Finance', 'SPV'], fn: renderPiutang },
  { k: 'hutang', l: '🏭 Hutang Supplier', roles: ['Owner', 'Manager', 'Admin Finance', 'SPV'], fn: renderHutangSupplier },
  { k: 'komisi', l: '💸 Bayar Komisi', roles: ['Owner', 'Manager', 'Admin Finance'], fn: renderBayarKomisi },
  { k: 'dp', l: '💵 DP', roles: ['Owner', 'Manager', 'Admin Finance', 'SPV', 'Teknisi'], fn: renderLapDP },
];
let shpTab = 'bayar';

/** Pra-pilih tab sebelum membuka menu (mis. alert Dashboard → tab DP/Piutang). */
export const setStatusHubTab = (k: string): void => { if (SHP_TABS.some((t) => t.k === k)) shpTab = k; };

export async function renderStatusHutangPiutang(root: HTMLElement): Promise<void> {
  const u = currentUser()!;
  const tabs = SHP_TABS.filter((t) => t.roles.includes(u.role));
  if (!tabs.length) { root.innerHTML = '<div class="panel"><div class="empty">Tidak ada akses.</div></div>'; return; }
  if (!tabs.some((t) => t.k === shpTab)) shpTab = tabs[0]!.k; // default = tab pertama yang boleh dilihat peran ini
  // Tanda pada TAB, bukan cuma pada menu (permintaan Apo): dari luar Apo hanya melihat satu angka
  // di sidebar dan tak tahu tab mana yang menuntut tindakan. Dihitung setelah bar terpasang supaya
  // tab tetap bisa diklik walau hitungannya lambat/gagal.
  const bar = tabs.map((t) => `<button class="btn ${shpTab === t.k ? 'primary' : ''}" data-shp="${t.k}" style="padding:5px 11px;font-size:12.5px">${t.l}<span data-shpbadge="${t.k}"></span></button>`).join(' ');
  root.innerHTML = `<div class="ttl">💳 Status Hutang, Piutang</div>
    <div style="display:flex;gap:6px;margin:10px 0 12px;flex-wrap:wrap;padding-bottom:10px;border-bottom:1px solid var(--line)">${bar}</div>
    <div id="shp_body"><div class="panel"><div class="empty">Memuat…</div></div></div>`;
  root.querySelectorAll<HTMLElement>('button[data-shp]').forEach((b) => b.addEventListener('click', () => { shpTab = b.dataset.shp ?? 'bayar'; void renderStatusHutangPiutang(root); }));
  const body = root.querySelector('#shp_body') as HTMLElement;
  const active = tabs.find((t) => t.k === shpTab) ?? tabs[0]!;
  await active.fn(body);

  // 🏭 Hutang Supplier: tandai jumlah supplier yang MENAGIH dan tagihannya belum tuntas.
  if (tabs.some((t) => t.k === 'hutang') && ['Owner', 'Manager', 'Admin Finance'].includes(u.role)) {
    try {
      const n = await supplierMenagihCount();
      const slot = root.querySelector<HTMLElement>('[data-shpbadge="hutang"]');
      if (slot && n > 0) slot.innerHTML = ` <span class="pill" style="background:var(--danger);color:#fff;font-weight:700" title="Supplier menagih dan belum lunas">📣 ${n}</span>`;
    } catch { /* tanda opsional — jangan menggagalkan layar */ }
  }
}
